import axios from 'axios'
import jwtDefaultConfig from './jwtDefaultConfig'

export default class JwtService {
    // ** jwtConfig <= Will be used by this service
    jwtConfig = { ...jwtDefaultConfig }

    constructor(jwtOverrideConfig) {
        this.jwtConfig = { ...this.jwtConfig, ...jwtOverrideConfig }

        // ** Request Interceptor
        axios.interceptors.request.use(
            (config) => {
                // ** Get token from localStorage
                const accessToken = this.getToken()
                // ** If token is present add it to request's Authorization Header
                if (accessToken) {
                    // ** eslint-disable-next-line no-param-reassign
                    config.headers.Authorization = `${this.jwtConfig.tokenType} ${accessToken}`
                    config.headers[`${this.jwtConfig.storageTokenKeyName}`] = accessToken
                }
                return config
            },
            (error) => Promise.reject(error)
        )

        // ** Add request/response interceptor
        axios.interceptors.response.use(
            (response) => response,
            (error) => {
                // ** const { config, response: { status } } = error
                const { response } = error
                //const originalRequest = config;

                // ** if (status === 401) {
                if (response && response.status === 401) {
                    this.logout()
                }
                if (response && response.status === 400) {
                    const { data } = response
                    if (data.error == 'Provided token is expired.') {
                        this.logout()
                    }
                }
                return Promise.reject(error)
            }
        )
    }

    getToken() {
        return localStorage.getItem(this.jwtConfig.storageTokenKeyName)
    }

    setToken(value) {
        localStorage.setItem(this.jwtConfig.storageTokenKeyName, value)
    }

    login(credentials) {
        const args = { ...credentials, bearer: process.env.REACT_APP_BEARER_API }
        return axios.post(this.jwtConfig.login, args)
    }

    logout() {
        localStorage.removeItem('dataUser')
        localStorage.removeItem(this.jwtConfig.storageTokenKeyName)
        window.location.href =
            !process.env.NODE_ENV || process.env.NODE_ENV === 'development'
                ? process.env.ROOT_APP_ENV + '/login'
                : process.env.ROOT_APP_PRODUCTION + '/login'
    }
}
